(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["buy-sell-header"]) return;
  try {
    
  if (document.getElementsByName('input[name="tt_site_switcher"]')) {
      let siteSwitcher = document.querySelector('input[name="tt_site_switcher"]');
      let buyLink = document.querySelector('a.buy-link');
      let sellLink = document.querySelector('a.sell-link');

      siteSwitcher.addEventListener('click', (e) => {

          let checked = siteSwitcher.checked; // latest state
          let url = buyLink.href;
          if (checked) {
              url = sellLink.href;
          }
          setTimeout(function () {
              window.location.href = url;
          }, 100);

      });
      buyLink.addEventListener('click', (e) => {
          siteSwitcher.checked = false;
          siteSwitcher.dispatchEvent(new Event('click'));
      });
      sellLink.addEventListener('click', (e) => {
          siteSwitcher.checked = true;
          siteSwitcher.dispatchEvent(new Event('click'));
      });
  }
  
  window.addEventListener("pagehide", function () {
      // Keep checkbox state correct when using browser back/forward
      let siteSwitcher = document.querySelector('input[name="tt_site_switcher"]');
      let thisSiteState = true; // IMPORTANT WHEN UPDATING!
      siteSwitcher.checked = thisSiteState;
  });


  } catch(e) { console.error(e); }
})();
})();
